import React, { useEffect, useState } from 'react';
import { Box, List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CategoryCreators } from 'store/categories/categories-duck.js';
import PropTypes from 'prop-types';

const ProductSidebarMenu = ({ categories, categoriesFetchAsync }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryId = searchParams.get('categoryId');
  const subCategoryId = searchParams.get('subCategoryId');

  const [openCategoryId, setOpenCategoryId] = useState(categoryId || '');

  useEffect(() => {
    if (categories.length === 0) categoriesFetchAsync();
  }, [categories, categoriesFetchAsync]);

  const handleClickAll = () => {
    setOpenCategoryId('');
    navigate('/products');
  };

  const handleClickCategory = (category) => {
    navigate(`/products?categoryId=${category.id}`);
    if (category.subCategories?.length > 0) {
      setOpenCategoryId(category.id);
    } else {
      setOpenCategoryId('');
    }
  };

  const handleClickSubcategory = (subId) => {
    navigate(`/products?subCategoryId=${subId}`);
  };

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 220 },
        bgcolor: 'white',
        color: 'black',
        borderRadius: 2,
        p: 2,
        maxHeight: 'fit-content',
      }}
    >
      <List dense disablePadding>
        {/* TODOS OS PRODUTOS */}
        <ListItemButton
          selected={!categoryId && !subCategoryId}
          onClick={handleClickAll}
          sx={{ color: 'black', mb: 1 }}
        >
          <ListItemText
            primary="Todos os produtos"
            slotProps={{ primary: { style: { fontWeight: 'bold' } } }}
          />
        </ListItemButton>

        {/* CATEGORIAS E SUBCATEGORIAS */}
        {categories.map((cat) => (
          <Box key={cat.id}>
            <ListItemButton
              selected={categoryId === cat.id && !subCategoryId}
              onClick={() => handleClickCategory(cat)}
              sx={{ color: 'black' }}
            >
              <ListItemText
                primary={cat.name}
                slotProps={{ primary: { style: { fontWeight: 'bold' } } }}
              />
            </ListItemButton>

            {/* Subcategorias aparecem apenas se a categoria está aberta */}
            {cat.subCategories?.length > 0 && (
              <Collapse in={openCategoryId === cat.id} timeout="auto" unmountOnExit>
                <List dense component="div" disablePadding>
                  {cat.subCategories.map((sub) => (
                    <ListItemButton
                      key={sub.id}
                      sx={{ pl: 4, color: 'black' }}
                      selected={subCategoryId === sub.id}
                      onClick={() => handleClickSubcategory(sub.id)}
                    >
                      <ListItemText primary={sub.name} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </Box>
        ))}
      </List>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  categories: state.Category.categories,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      categoriesFetchAsync: CategoryCreators.categoriesFetchAsync,
    },
    dispatch,
  );

ProductSidebarMenu.propTypes = {
  categories: PropTypes.array.isRequired,
  categoriesFetchAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSidebarMenu);
